<template>
  <div style="text-align: center">
    <van-nav-bar
      id="reset"
      title="检测预约"
      left-text="上一步"
      left-arrow
      @click-left="goback"
    />

    <h3 style="font-weight:900">填写基本信息</h3>
    <van-form 
      validate-first 
      @failed="onFailed" 
      @submit="nextStep"
      :label-width = "120"
    >
      <!-- 通过 pattern 进行正则校验 -->
      <van-field
        v-model="form.name"
        name="姓名"
        label="姓名"
        required
        placeholder=""
        :rules="[
          {
            required: true,
            message: '姓名格式不正确',
          },
        ]"
      />
      <van-field
        readonly
        clickable
        name="picker"
        v-model="form.gender"
        label="性别"
        required
        placeholder=""
        @click="picker.gender = true"
        :rules="[
          {
            required: true,
            message: '请选择性别',
          },
        ]"
      />
      <van-popup v-model="picker.gender" position="bottom">
        <van-picker
          show-toolbar
          :columns="genderList"
          @confirm="confirmGender"
          @cancel="picker.gender = false"
        />
      </van-popup>

      <van-field
        readonly
        v-model="form.address"
        name="pattern"
        label="地区"
        required
        @click="picker.region = true"
        placeholder=""
        :rules="[
          {
            required: true,
            message: '请选择地区',
          },
        ]"
      />

      <van-field
        v-if = "otherAddressShow"
        v-model="otherAddress"
        name="pattern"
        label="其他地区"
        required
        placeholder="请输入您所在的城市..."
        :rules="[
          {
            required: true,
            message: '请选择地区',
          },
        ]"
      />

      <van-popup v-model="picker.region" position="bottom">
        <van-picker
          show-toolbar
          :columns="regionList"
          @confirm="confirmRegion"
          @cancel="picker.region = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        name="datetimePicker"
        v-model="form.birthDate"
        label="出生日期"
        required
        placeholder=""
        @click="picker.birthDate = true"
        :rules="[
          {
            required: true,
            message: '请选择正确的出生日期',
          },
        ]"
      />
      <van-popup v-model="picker.birthDate" position="bottom">
        <van-datetime-picker
          type="date"
          v-model="currentBirthDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="confirmBirthDate"
          @cancel="picker.birthDate = false"
        />
      </van-popup>

      <van-field
        required
        readonly
        label="年龄"
        v-model="age"
        name="pattern"
        placeholder="年龄"

      />
      <van-field
        required
        label="单位"
        v-model="form.company"
        name="pattern"
        placeholder="您所在的单位..."
        :rules="[
          {
            required: true,
            message: '请输入您所在的单位',
          },
        ]"
      />
      <van-field
        required
        label="职务"
        v-model="form.profession"
        name="pattern"
        placeholder="您所担任的职务..."
        :rules="[
          {
            required: true,
            message: '请输入您担任的职务',
          },
        ]"
      />
      <van-field
        required
        label="身高/cm"
        v-model="form.height"
        type="number"
        name="pattern"
        placeholder="请输入身高"
        :rules="[
          {
            required: true,
            message: '请输入您的身高',
          },
        ]"
      />
      <van-field
        required
        label="体重/kg"
        v-model="form.weight"
        type="number"
        name="pattern"
        placeholder=""
        :rules="[
          {
            required: true,
            message: '请输入您的体重',
          },
        ]"
      />
      <van-field
        label="紧急联系人电话"
        v-model="form.emergencyCall"
        type="number"
        name="pattern"
        placeholder=""
        :rules="[
          {
            required: false,
            message: '请输入正确的电话号码',
            validator : (value) => {
              if(this.teleNumPattern.test(value) || value ==''){
                return true
              }
              else{
                return false
              }
            }
          }
        ]"
        
      />
      
      <van-field
        label="备注"
        v-model="form.memo"
        name="pattern"
        placeholder=""
        :rules="[
          {
            required: false,
            message: '请输入备注信息',
          },
        ]"
      />
      <!-- <van-field
        required
        readonly
        clickable
        name="picker"
        v-model="form.marriage"
        label="是否已育"
        placeholder=""
        @click="picker.marrigae = true"
      />
      <van-popup v-model="picker.marrigae" position="bottom">
        <van-picker
          show-toolbar
          :columns="marriageList"
          @confirm="confirmMarriage"
          @cancel="picker.marrigae = false"
        />
      </van-popup> -->
      <div style="margin: 16px">
        <van-button
          type="warning"
          block
          native-type="submit"
          class="nextStepBtn"
          :disabled="permission"
          >下一步</van-button
        >
      </div>
    </van-form>
    <!-- <van-dialog v-model="showInstructions" title="" show-cancel-button>
      <Instructions />
    </van-dialog> -->
  </div>
</template>

<script type="text/ecmascript-6">
// import axios from "axios";

import Moment from "moment";
import {getUserInfo, updateUserInfo } from "../../../api/userService";
// import Instructions from "./instructions"

function calculateAge(startDate, endDate) {  
            const start = new Date(startDate);  
            const end = new Date(endDate);  
            const diffMilliseconds = end - start;  

            const years = Math.floor(diffMilliseconds / (365.25 * 24 * 60 * 60 * 1000));  
            return `${years} years`;  
          }  

export default {
  name: "login",
  components:{
    // Instructions,
  },
  data() {
    return {
      // 电话类型判断
      teleNumPattern: /^1[3456789]\d{9}$/,
      //检测须知对话框
      // showInstructions:false,
      regionList:[
        "长沙",
        "重庆",
        "珠海",
        "上海",
        "其他"
      ],
      genderList: ["男", "女"],
      // marriageList:["未生育","已生育"],
      picker: {
        gender: false,
        region: false,
        birthDate: false,
        // marrigae: false,
      },
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2020, 10, 1),
      currentBirthDate: new Date(1970,0,1),
      age: "",
      otherAddress:"",
      form: {
        name: "",
        address: "",
        //默认生日： 1970-01-01
        birthDate: Moment(new Date(1970,0,1)).format("YYYY-MM-DD"),
        gender: "",
        height: "",
        marriage: "",
        company: "",
        profession: "",
        userInfoTeleNum: sessionStorage.getItem("teleNum"),
        weight: "",
        emergencyCall: "",
        memo:""
      },
    };
  },
  computed: {
    otherAddressShow(){
      if(this.form.address =="其他"){
        return true
      }else{
        return false
      }
    },
    teleNum() {
      if(this.$store.state.teleNum == ""){
        return sessionStorage.getItem("teleNum")
      }
      return this.$store.state.teleNum
    },
    permission() {
      if(this.form.name == "" || this.form.birthDate == "" || this.form.gender ==""){
        return true
      }
      else{
        return false
      }
    }
  },

  // 里面的函数只有调用才会执行
  methods: {
    selectRegion(value){
      this.form.address = value;
    },
    submit(){

    },
//检测须知
    testWarnings(){
      // this.showInstructions = true;
      this.$router.push({path:"/appIndex/instructions"})
    },
// input 选项确认
    confirmRegion(value) {
      this.form.address = value;
      this.picker.region = false;
      //如果选择的地区 不是‘其他’，则清空data中的其他区域字段
      if(value !="其他"){
        this.otherAddress = "";
      }
    },
    confirmGender(value) {
      this.form.gender = value;
      this.picker.gender = false;
    },
    confirmBirthDate(value) {
      this.form.birthDate = Moment(value).format("YYYY-MM-DD");
      this.form.currentBirthDate = this.form.birthDate;
      this.age =
        new Date().getFullYear() - new Date(value).getFullYear();
      this.picker.birthDate = false;
    },
    // confirmMarriage(value) {
    //   this.form.marriage = value;
    //   this.picker.marrigae = false;
    // },
//校验器
    // 校验函数返回 true 表示校验通过，false 表示不通过
    validator(val) {
      return /1\d{10}/.test(val);
    },
//表单提交错误后
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
//下一步
    nextStep() {
      this._updateUserInfo()

    },
    goback() {
      this.$router.go(-1);
    },
//获取用户基本信息api
    _getUserInfo() {
      let that = this;
      //我的诊断中获取用户基本信息
      getUserInfo(this.teleNum ).then((res) => {
        // console.log(res);
        //基础信息
        if( res.data[0] ) {
          that.form = res.data[0];
          that.form.birthDate = Moment(that.form.birthDate).format("YYYY-MM-DD");



          that.age = calculateAge(new Date(), new Date(that.form.birthDate));

          if(that.form.address){
            //如果选择区域是 默认的四个地区的话，则otherAddress设为空，
            if( that.regionList.includes(that.form.address) ){
              that.otherAddress = ""
            //如果不是默认四个地区的话
            }else{
              //otherAddress改为地区名，
              //this.form.address与popup picker中的 address设为其他;
              that.otherAddress = that.form.address;
              that.form.address = "其他"
              that.address = "其他"
            }
            // this.defaultAddressConfig()
            return
          }else{
            that.defaultAddressConfig()
          }
          // this.age =  new Date().getFullYear() - new Date(this.form.birthDate.replace(/-/g, "/")).getFullYear();
        }
        that.defaultAddressConfig()
        // //如果基础信息存在的话，说明已经录入过，则用户可以进入下一步
        // if (this.form) {
        //   this.tabs.userInfo.ableToNextStep = true;
        // }
      });
    },
    _updateUserInfo() {
      //由于对象是 引用类型；所以需要创建一个副本；
      let formatForm = Object.assign({},this.form);
      formatForm.birthDate = Moment(formatForm.birthDate).format("YYYY-MM-DD HH:MM:SS");
      formatForm.weight = parseFloat(formatForm.weight);
      formatForm.height = parseFloat(formatForm.height);

      if(formatForm.address == "其他" ){
        formatForm.address = this.otherAddress;
      }

      // console.log("form",this.form);
      // console.log("formatForm",formatForm);
      // console.log(JSON.stringify(this.form));

      updateUserInfo(JSON.stringify(formatForm))
        .then((res) => {
          if (res.success) {
            //更新用户信息显示
            // this.form = res.data[0].userInfo;
            // this.age =  new Date().getFullYear() - new Date(this.form.birthDate).getFullYear();
            //操作成功后 跳转到 绝对禁忌症页面
            this.$router.push({ path: "/appIndex/absoluteContradictions" });
          } else {
            //如果接口调用失败则 告知用户错误信息
            this.$notify({type:"error",message:res.description});
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    defaultAddressConfig(){
      // let that = this;
        this.$jsonp('http://api.map.baidu.com/location/ip?ak=9zNKGguAbdNC6xwD7syftt533eIf7cSn')
        .then((res)=>{
          let s = res.content.address_detail.city;
          // console.log( s.substr(0,s.length-1),"my success");
          this.form.address = s.substr(0,s.length-1);
        })
    }

  },
  // 创建完毕状态(里面是操作)
  created() {
    this._getUserInfo();

  },
};
</script>

<style scoped>
/**style for top bar */
.van-nav-bar {
  background: linear-gradient(to right, #77bbe3, #1270c6);
}
#reset /deep/ .van-ellipsis {
  font-size: 18px;
  color: white !important;
}
#reset /deep/ .van-nav-bar__text {
  color: white !important;
}
/** top bar style end*/
</style>
